import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

import playIcon from "../images/icons/play--white.svg"
import ResponsiveWrapper from "./ResponsiveWrapper"

const Thumbnail = styled.div`
  height: 100%;
  opacity: 1;
  position: relative;
  transition: opacity ${({ theme }) => theme.transitionTime};

  ${(props) =>
    props.$showDarkOverlay &&
    css`
      ${PlayOverlay} {
        background-color: ${({ theme }) => `rgba(${theme.spaceblueRGB},0.4)`};
      }
    `}

  > img,
  > svg {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }

  .gatsby-image-wrapper {
    height: 100%;
    width: 100%;
  }
`

const Focus = styled.div`
  background: #000;
  outline-offset: 3px !important;

  ${(props) =>
    props.$isPlaying &&
    css`
      ${Thumbnail} {
        opacity: 0;
      }
    `}
`

const Iframe = styled.iframe`
  z-index: 5;
`

export const PlayOverlay = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;

  .icon--play {
    height: auto;
    transition: transform ${({ theme }) => theme.transitionTime};
    width: clamp(50px, 12%, 100px);
  }

  &:hover {
    .icon--play {
      transform: scale(1.1);
    }
  }
`

const Player = ({ youtubeId }) => {
  return (
    <Iframe
      allow="autoplay; encrypted-media"
      title="YouTube"
      allowFullScreen
      frameBorder="0"
      height="315"
      src={`https://www.youtube-nocookie.com/embed/${youtubeId}?rel=0&amp;showinfo=0&amp;autoplay=1&amp;modestbranding=1&amp;controls=1`}
      width="560"
    />
  )
}

const YouTubePlayer = (props) => {
  const youtubeId = props.url.match(/v=([^&]*)/)[1]
  const [isPlaying, setPlaying] = useState(false)

  useEffect(() => {
    if (props.isPlaying === false) {
      setPlaying(props.isPlaying)
    }
  }, [props])

  useEffect(() => {
    setPlaying(props.isPlaying)
  }, [props])

  return (
    <ResponsiveWrapper>
      {isPlaying && <Player youtubeId={youtubeId} />}
      <Focus
        onClick={() => setPlaying(true)}
        onKeyPress={() => setPlaying(true)}
        role="button"
        tabIndex={0}
        $isPlaying={isPlaying}
      >
        <Thumbnail $showDarkOverlay={props.showDarkOverlay}>
          <PlayOverlay>
            {props.showPlayIcon ? (
              <img src={playIcon} alt="Video" className="icon--play" />
            ) : null}
          </PlayOverlay>
          {props.thumbnail}
        </Thumbnail>
      </Focus>
    </ResponsiveWrapper>
  )
}

YouTubePlayer.propTypes = {
  url: PropTypes.string.isRequired,
  isPlaying: PropTypes.bool,
  thumbnail: PropTypes.object.isRequired,
}

export default YouTubePlayer
